__turbopack_context__.v({
  "container": "TermsSection-module-scss-module__yeA8TG__container",
});
